import * as types from './types';
import toastFactory from './factory';
import type { AppDispatch } from '../../types';


export function addToast(properties: types.Toast) {
  return async (dispatch: AppDispatch) => {
    const toast = toastFactory(properties);
    dispatch({ type: types.ADD_TOAST, payload: toast });
  };
}

export function removeToast(id: number) {
  return (dispatch: AppDispatch) => {
    dispatch({ type: types.REMOVE_TOAST, payload: id });
  };
}
